<template>
    <BaseView contentClass="bg-white">
        <template v-slot:top>
            <TitleBar
                :title="$t('Notifications')"
                @left-click="close"
            >
                <template v-slot:leftIcon>
                    <CloseIcon />
                </template>
            </TitleBar>
            <SearchBar
                @search="updateSearch"
                @filter="openFilterModal"
            />
        </template>

        <template v-if="notifications && notifications.length > 0">
            <div class="notifications">
                <template v-for="notification in notifications">
                    <Notification
                        :key="notification.id"
                        :notification="notification"
                        @click="openDetailsModal(notification)"
                    />
                </template>
            </div>


            <div class="flex justify-center">
                <div v-if="loading" class="p-4 flex-col text-80">
                    <loader />
                </div>

                <button
                    v-if="!loading && hasMore"
                    class="btn btn-default btn-primary main-button mb-3"
                    type="text"
                    @click="loadMore"
                    >
                    {{ $t("Load more") }}
                </button>
            </div>
        </template>

        <div v-else class="middle-of-page">
            {{ $t("There are no notifications.") }}
        </div>

        <portal to="modals">
            <transition name="fade">
                <NotificationDetailsModal
                v-if="detailsModalOpen"
                :notification="selectedNotification"
                @close="closeDetailsModal"
                />

                <NotificationFilterModal
                v-if="filterModalOpen"
                :filters="filters"
                @update="updateFilters"
                @close="closeFilterModal"
                />
            </transition>
        </portal>

  </BaseView>
</template>

<script>
import Notification from '@mobile/views/Notifications/Items/Notification.vue';
import NotificationDetailsModal from '@mobile/views/Notifications/Modals/Details.vue';
import NotificationFilterModal from '@mobile/views/Notifications/Modals/Filter.vue';
import Loader from '@mobile/components/Loader.vue';
import BaseView from '@mobile/components/BaseView.vue';
import CloseIcon from '@mobile/components/Icons/CloseIcon.vue';
import SearchBar from '@mobile/components/SearchBar.vue';
import TitleBar from '@/components/TitleBar.vue';
import { eventBus } from '@/eventBus';

export default {
    components: {
        Notification,
        NotificationDetailsModal,
        Loader,
        NotificationFilterModal,
        BaseView,
        TitleBar,
        CloseIcon,
        SearchBar,
    },

    props: {},

    data: () => ({
        detailsModalOpen: false,
        filterModalOpen: false,
        selectedNotification: null,
        filters: {
            from: null,
            to: null,
            status: null,
            search: null,
        },
        canGoBack: false,
    }),

    computed: {
        notifications() {
            return this.$store.getters['notifications/all'];
        },
        hasMore() {
            return this.$store.getters['notifications/has_next_page'];
        },
        loading() {
            return this.$store.getters['notifications/loading'];
        },
    },

    async created() {
        this.$store
            .dispatch('notifications/query', this.filters)
            .then(() => {
                eventBus.$emit('loaded');
            }).catch((error) => {
                eventBus.$emit('client-error', error);
            });

        this.$store
            .dispatch('notifications/unreadCount')
            .catch((error) => {
                eventBus.$emit('client-error', error);
            });
    },

    // this makes sure we only go back on close if that is still inside the app
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if (from.matched.length > 0) {
                vm.canGoBack = true;
            }
        })
    },


    methods: {

        openDetailsModal(notification) {
            this.selectedNotification = notification;
            this.detailsModalOpen = true;
            this.$store.dispatch('notifications/changeStatusToRead', { notificationId: notification.id });
        },

        closeDetailsModal() {
            this.detailsModalOpen = false;
            this.selectedNotification = null;
        },

        openFilterModal() {
            this.filterModalOpen = true;
        },

        closeFilterModal() {
            this.filterModalOpen = false;
        },

        updateFilters(filters) {
            eventBus.$emit('loading');
            this.filters = { ...this.filters, ...filters };
            this.$store
                .dispatch('notifications/query', { filters: this.filters })
                .catch((error) => {
                    eventBus.$emit('client-error', error);
                })
        },

        updateSearch(query) {
            eventBus.$emit('loaded');
            this.filters.search = query;
            this.$store
                .dispatch('notifications/query', { filters: this.filters })
                .catch((error) => {
                    eventBus.$emit('client-error', error);
                });
        },

        loadMore() {
            this.$store
                .dispatch('notifications/loadMore', { filters: this.filters })
                .catch((error) => {
                    eventBus.$emit('client-error', error);
                });
        },

        close() {
            if (this.canGoBack) {
                this.$router.go(-1);
            } else {
                this.$router.push({ name: 'todos' });
            }
        },

    },
};
</script>
